/**
 * ONE ICON PER LIVING ARRANGEMENT, everywhere it is shown (owner, 23 Oct 2026: Home's Start here rows, the saved
 * plans, the action plan and the menu showed different icons for the same module — downsizing and the granny
 * flat were both a plain house, the village guide had aged care's building). Keyed by plan type, with the
 * profile goal keys that name the same modules.
 */
import { Building, Home, Users, Trees, Coins } from 'lucide-react';
import DownsizeHome from './DownsizeHome.tsx';

type IconComponent = React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>;

export const MODULE_ICONS = {
    aged_care: Building,
    home_care: Home,
    retirement_village: Users,
    downsizer: DownsizeHome,
    granny_flat: Trees,
    cashflow_pension: Coins,
} satisfies Record<string, IconComponent>;

/** The same icons by profile goal key ('downsize_home' is the downsizing goal; 'cashflow' has no goal of its own). */
export const GOAL_ICONS = {
    aged_care: MODULE_ICONS.aged_care,
    home_care: MODULE_ICONS.home_care,
    retirement_village: MODULE_ICONS.retirement_village,
    downsize_home: MODULE_ICONS.downsizer,
    granny_flat: MODULE_ICONS.granny_flat,
    cashflow: MODULE_ICONS.cashflow_pension,
} satisfies Record<string, IconComponent>;
